import { generatePath } from "react-router-dom";

import { RoutePath } from "./routePath";

/**
 * Path constants for the insurance product domain.
 * Covers onboarding, billing, underwriting outcomes, coverage editing,
 * and post-purchase features (quote review, AD).
 */
export const RouteTemplates = {
  pendingDetails: "/products/insurance/:policyId/pending-details",
  coverageDenied: "/coverage-denied/:type",
  editCoverage: "/edit-coverage/:type/:billingFrequency",
  editCoverageNoFrequency: "/edit-coverage/:type",
} as const;

export const insurancePaths = {
  products: {
    select: "/products/select",
    insurance: {
      root: "/products/insurance",
      welcome: "/products/insurance/welcome",
      getWyshEstimate: "/products/insurance/get-wysh-estimate",
      getStarted: "/products/insurance/get-started",
      wyshBuilder: "/products/insurance/wysh-builder",
      estimate: "/products/insurance/estimate",
      billing: "/products/insurance/billing",
      manualReview: "/products/insurance/manual-review",
      inReview: "/products/insurance/in-review",
      confirmUpdate: "/products/insurance/confirm-update",
      pendingDetails: RoutePath(RouteTemplates.pendingDetails),
    },
  },
  // Optional :type param — explicit arrow function (RoutePath requires all params)
  coverageDenied: (params?: { type: string }) =>
    params ? generatePath(RouteTemplates.coverageDenied, params) : "/coverage-denied",
  coveragePreview: "/coverage-preview",
  // Optional :billingFrequency — explicit arrow function
  editCoverage: (params: { type: string; billingFrequency?: string }) =>
    params.billingFrequency
      ? generatePath(
          RouteTemplates.editCoverage,
          params as { type: string; billingFrequency: string }
        )
      : generatePath(RouteTemplates.editCoverageNoFrequency, params),
  gettingCoverage: "/getting-coverage",
  aboutAd: "/about-ad",
  reviewQuote: "/review-quote",
};
